// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footer__XXj-R {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: auto;
}
.footer_footer-inner__X0itl {
  backdrop-filter: blur(8px);
  border-top: 2px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 16px;
  width: 100%;
}
.footer_footer-inner__X0itl .footer_logo__IRoNB {
  width: 126px;
}
.footer_footer-inner__X0itl .footer_text__9aNvQ {
  color: #fff;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}
@media screen and (min-width: 1200px) {
  .footer_footer__XXj-R {
    margin-top: unset;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/footer/footer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: auto;\n}\n.footer-inner {\n  backdrop-filter: blur(8px);\n  border-top: 2px solid rgba(255, 255, 255, 0.05);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n  width: 100%;\n}\n.footer-inner .logo {\n  width: 126px;\n}\n.footer-inner .text {\n  color: #fff;\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 140%;\n}\n@media screen and (min-width: 1200px) {\n  .footer {\n    margin-top: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `footer_footer__XXj-R`,
	"footer-inner": `footer_footer-inner__X0itl`,
	"logo": `footer_logo__IRoNB`,
	"text": `footer_text__9aNvQ`
};
export default ___CSS_LOADER_EXPORT___;
